export default __webpack_public_path__ + "static/media/todolist1.bcd60368.png";